(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.IrrigationSettings2Controller = (function(superClass) {
    extend(IrrigationSettings2Controller, superClass);

    function IrrigationSettings2Controller(scope, transitions, zone_type, option_name, option_type, options, validation, pgis, zones_service) {
      var ref;
      this.scope = scope;
      this.transitions = transitions;
      this.zone_type = zone_type;
      this.validation = validation;
      this.pgis = pgis;
      this.zones_service = zones_service;
      this.convertSavedZones = bind(this.convertSavedZones, this);
      this.showOnMap = bind(this.showOnMap, this);
      this.deleteRow = bind(this.deleteRow, this);
      this.makeMappings = bind(this.makeMappings, this);
      this.makeExtraInfo = bind(this.makeExtraInfo, this);
      this.makeRanges = bind(this.makeRanges, this);
      this.makeCropRanges = bind(this.makeCropRanges, this);
      this.addRow = bind(this.addRow, this);
      this.addCrop = bind(this.addCrop, this);
      this.constrainRow = bind(this.constrainRow, this);
      this.loadRows = bind(this.loadRows, this);
      this.validate = bind(this.validate, this);
      if ((this.pgis.field_data == null) && !this.validation.canContinue()) {
        return;
      }
      this.scope.disabled.back = false;
      this.scope.field_data = ((ref = this.pgis) != null ? ref.field_data : void 0) != null ? this.pgis.field_data : this.validation.getFieldData();
      this.scope.zone = this.scope.field_data.zones[this.zone_type];
      this.scope.zone.zone_type = this.zone_type;
      this.scope.zone_type = this.zone_type;
      this.scope.selected = {
        crop: null
      };
      this.scope.field_data.visited_settings = true;
      this.scope.allowed_crops = ['Corn (grain)', 'Soybeans', 'Wheat', 'Cotton'];
      this.scope.crops = ['Corn (grain)', 'Soybeans', 'Wheat', 'Cotton'];
      this.scope.all_crops_added = false;
      this.scope.crop_ranges = this.makeCropRanges();
      this.scope.used_for_fertilizer = false;
      this.scope.adding_crop = false;
      this.scope.rows = [];
      this.loadRows();
      this.scope.validation = this.validation;
      this.scope.validate = this.validate;
      this.scope.validation.setStepScope(this.scope);
      this.scope.addCrop = this.addCrop;
      this.scope.addRow = this.addRow;
      this.scope.constrainRow = this.constrainRow;
      this.scope.deleteRow = this.deleteRow;
      this.showOnMap(this.scope.field_data.zones.irrigation);
      this.scope.$watchCollection((function(_this) {
        return function() {
          var row;
          return (function() {
            var i, len, ref1, results;
            ref1 = this.scope.rows;
            results = [];
            for (i = 0, len = ref1.length; i < len; i++) {
              row = ref1[i];
              results.push(row.crop);
            }
            return results;
          }).call(_this);
        };
      })(this), (function(_this) {
        return function(vals, old) {
          var crop;
          return _this.scope.crops = (function() {
            var i, len, ref1, results;
            ref1 = this.scope.allowed_crops;
            results = [];
            for (i = 0, len = ref1.length; i < len; i++) {
              crop = ref1[i];
              if (indexOf.call(vals, crop) < 0) {
                results.push(crop);
              }
            }
            return results;
          }).call(_this);
        };
      })(this));
      this.scope.$watch('crops.length', (function(_this) {
        return function(val, old) {
          return _this.scope.all_crops_added = val === 0;
        };
      })(this));
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          _this.pgis.setIrrigationZone(_this.scope.zone);
          if (_.startsWith($transition.to().name, 'grower.fields-define')) {
            return _this.scope.died_willingly = true;
          }
        };
      })(this));
      this.scope.$parent.steps.once('switch-from', "grower.fields-define." + this.zone_type + "-settings1", (function(_this) {
        return function(data) {
          if (data.is_forward) {
            _this.scope.field_data.visited_settings = null;
            return _this.validation.setFieldData(_this.scope.field_data);
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var area, i, len, ref1;
          if (!_this.scope.died_willingly) {
            _this.validation.clearLayers();
            _this.validation.settings = {};
          }
          ref1 = _this.scope.field_data.zones.irrigation.zones;
          for (i = 0, len = ref1.length; i < len; i++) {
            area = ref1[i];
            App.map.removeLayer(area.visible);
          }
          return _this.transitionStart();
        };
      })(this));
      this.scope.validation.validate();
      this.validation.setBackButtonDisable(this.scope.field_data, 'add-crop');
    }

    IrrigationSettings2Controller.prototype.validate = function(ending) {
      var i, len, ref, ref1, ref2, row;
      this.validation.setFieldData(this.scope.field_data);
      if (!this.scope.rows.length) {
        return false;
      }
      ref = this.scope.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        if (!row.crop || !((ref1 = row.irrigated_range) != null ? ref1.min : void 0) || !((ref2 = row.dryland_range) != null ? ref2.min : void 0)) {
          return false;
        }
      }
      if (this.scope.adding_crop) {
        return false;
      }
      this.scope.field_data.zones.irrigation.extra_info = this.makeExtraInfo();
      return true;
    };

    IrrigationSettings2Controller.prototype.loadRows = function() {
      var crop, i, len, ref, ref1, ref2, ref3, ref4, ref5, row;
      if (((ref = this.scope.field_data.zones.irrigation.extra_info) != null ? ref.crops : void 0) != null) {
        ref1 = this.scope.field_data.zones.irrigation.extra_info.crops;
        for (i = 0, len = ref1.length; i < len; i++) {
          crop = ref1[i];
          row = this.scope.field_data.zones.irrigation.extra_info.mappings[crop];
          row.crop = crop;
          this.scope.rows.push(row);
        }
      }
      if (((ref2 = this.scope.field_data.zones.irrigation.extra_info) != null ? ref2.used_for_fertilizer : void 0) != null) {
        this.scope.used_for_fertilizer = this.scope.field_data.zones.irrigation.extra_info.used_for_fertilizer;
      }
      if ((((ref3 = this.validation.settings) != null ? ref3.crop : void 0) != null) && (ref4 = (ref5 = this.validation.settings) != null ? ref5.crop : void 0, indexOf.call((function() {
        var j, len1, ref6, results;
        ref6 = this.scope.rows;
        results = [];
        for (j = 0, len1 = ref6.length; j < len1; j++) {
          row = ref6[j];
          results.push(row.crop);
        }
        return results;
      }).call(this), ref4) < 0)) {
        this.scope.rows.push({
          irrigated_range: null,
          dryland_range: null,
          crop: this.validation.settings.crop,
          deletable: false,
          has_fieldprint: true,
          has_rx: false
        });
      }
      if (this.scope.field_data.process_mode === 'add-crop') {
        this.convertSavedZones();
      }
      if (!this.scope.rows.length) {
        return this.scope.adding_crop = true;
      }
    };

    IrrigationSettings2Controller.prototype.constrainRow = function(row, irrigated_changed) {
      var ref, ref1, ref2;
      if (irrigated_changed) {
        if (((ref = row.dryland_range) != null ? ref.min : void 0) >= ((ref1 = row.irrigated_range) != null ? ref1.min : void 0)) {
          return row.dryland_range = this.scope.crop_ranges[row.crop]['Dryland'].find((function(_this) {
            return function(element) {
              return element.min === row.irrigated_range.max;
            };
          })(this));
        }
      } else {
        if (((ref2 = row.dryland_range) != null ? ref2.min : void 0) >= row.irrigated_range.min) {
          return row.irrigated_range = this.scope.crop_ranges[row.crop]['Irrigated'].find((function(_this) {
            return function(element) {
              return element.max === row.dryland_range.min;
            };
          })(this));
        }
      }
    };

    IrrigationSettings2Controller.prototype.addCrop = function() {
      return this.scope.adding_crop = true;
    };

    IrrigationSettings2Controller.prototype.addRow = function() {
      this.scope.rows.push({
        crop: this.scope.selected.crop,
        irrigated_range: null,
        dryland_range: null,
        deletable: true,
        has_fieldprint: false,
        has_rx: false
      });
      this.scope.selected.crop = null;
      return this.scope.adding_crop = false;
    };

    IrrigationSettings2Controller.prototype.makeCropRanges = function() {
      var x;
      return {
        'Corn (grain)': this.makeRanges((function() {
          var i, results;
          results = [];
          for (x = i = 360; i >= 0; x = i += -20) {
            results.push(x);
          }
          return results;
        })()),
        Soybeans: this.makeRanges((function() {
          var i, results;
          results = [];
          for (x = i = 120; i >= 0; x = i += -5) {
            results.push(x);
          }
          return results;
        })()),
        Wheat: this.makeRanges((function() {
          var i, results;
          results = [];
          for (x = i = 120; i >= 0; x = i += -5) {
            results.push(x);
          }
          return results;
        })()),
        Cotton: this.makeRanges((function() {
          var i, results;
          results = [];
          for (x = i = 3000; i >= 400; x = i += -200) {
            results.push(x);
          }
          return results;
        })(), 'lbs/ac')
      };
    };

    IrrigationSettings2Controller.prototype.makeRanges = function(values, units) {
      var i, index, len, range, ranges, value;
      if (units == null) {
        units = 'bu/ac';
      }
      ranges = [];
      for (index = i = 0, len = values.length; i < len; index = ++i) {
        value = values[index];
        if (index < values.length - 1) {
          ranges.push({
            text: values[index + 1] + "-" + value + " " + units,
            value: values[index + 1] + "-" + value,
            min: value,
            max: values[index + 1],
            units: units
          });
        }
      }
      ranges.sort(function(a, b) {
        return b.min - a.min;
      });
      return {
        'Irrigated': (function() {
          var j, len1, results;
          results = [];
          for (index = j = 0, len1 = ranges.length; j < len1; index = ++j) {
            range = ranges[index];
            if (index !== ranges.length - 1) {
              results.push(range);
            }
          }
          return results;
        })(),
        'Dryland': (function() {
          var j, len1, results;
          results = [];
          for (index = j = 0, len1 = ranges.length; j < len1; index = ++j) {
            range = ranges[index];
            if (index !== 0) {
              results.push(range);
            }
          }
          return results;
        })()
      };
    };

    IrrigationSettings2Controller.prototype.makeExtraInfo = function() {
      var extra_info, row;
      return extra_info = {
        deletable: indexOf.call((function() {
          var i, len, ref, results;
          ref = this.scope.rows;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            row = ref[i];
            results.push(row.deletable);
          }
          return results;
        }).call(this), false) < 0,
        used_for_fertilizer: this.scope.used_for_fertilizer,
        crops: (function() {
          var i, len, ref, results;
          ref = this.scope.rows;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            row = ref[i];
            results.push(row.crop);
          }
          return results;
        }).call(this),
        mappings: this.makeMappings()
      };
    };

    IrrigationSettings2Controller.prototype.makeMappings = function() {
      var i, len, mappings, ref, row;
      mappings = {};
      ref = this.scope.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        mappings[row.crop] = {
          irrigated_range: row.irrigated_range,
          dryland_range: row.dryland_range,
          units: row.units,
          deletable: row.deletable
        };
      }
      return mappings;
    };

    IrrigationSettings2Controller.prototype.deleteRow = function(row) {
      return this.scope.rows = this.scope.rows.filter((function(_this) {
        return function(element) {
          return element.crop !== row.crop;
        };
      })(this));
    };

    IrrigationSettings2Controller.prototype.showOnMap = function(zones) {
      var area, geojson, i, len, ref, results;
      ref = zones.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        area = ref[i];
        geojson = area.visible.toGeoJSON();
        area.visible.clearLayers();
        L.geoJson(geojson).eachLayer((function(_this) {
          return function(l) {
            l.setStyle({
              weight: 2,
              color: area.color,
              fillOpacity: 0.6
            });
            area.visible.addLayer(l);
            return _this.validation.pgis.added_layers.push(l);
          };
        })(this));
        results.push(area.visible.addTo(App.map));
      }
      return results;
    };

    IrrigationSettings2Controller.prototype.convertSavedZones = function() {
      var area, i, index, len, ref, results, style, zone;
      ref = this.scope.field_data.zones.irrigation.loaded_zones;
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        area = ref[index];
        if (this.scope.field_data.zones.irrigation.zones.filter(function(z) {
          return z.id === area.id;
        }).length) {
          continue;
        }
        area.settings = {};
        area.visible = new L.FeatureGroup();
        area.unclipped = new L.FeatureGroup();
        area.color = this.zones_service.getNextColor(null, index);
        area.identity = area.id;
        style = this.zones_service.defaultZoneStyle(area.color);
        zone = _.clone(area);
        L.geoJson(zone.geometry).eachLayer((function(_this) {
          return function(layer) {
            layer.setStyle(style != null ? style : {});
            zone.visible.addLayer(layer);
            zone.unclipped.addLayer(layer);
            _this.pgis.added_layers.push;
            return zone.visible.addTo(App.map);
          };
        })(this));
        zone = this.zones_service.setZoneArea(zone);
        if ((zone != null ? zone.extra_info : void 0) != null) {
          zone.extra_info = JSON.parse(zone.extra_info);
        }
        results.push(this.scope.field_data.zones.irrigation.zones.push(zone));
      }
      return results;
    };

    return IrrigationSettings2Controller;

  })(Controller);

}).call(this);
